import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Dashboard } from '@app/Dashboard/Dashboard';
import { SecurityFeed } from '@app/SecurityFeed/SecurityFeed';
import { About } from '@app/About/About';
import { NotFound } from '@app/NotFound/NotFound';

export interface IAppRoute {
  label?: string; // Excluding the label will exclude the route from the nav sidebar in AppLayout
  element: React.ReactElement;
  exact?: boolean;
  path: string;
  title: string;
  routes?: undefined;
}

export interface IAppRouteGroup {
  label: string;
  routes: IAppRoute[];
}

export type AppRouteConfig = IAppRoute | IAppRouteGroup;

const routes: AppRouteConfig[] = [
  {
    element: <Dashboard />,
    exact: true,
    label: 'Overview',
    path: '/',
    title: 'Hummingbird | Overview',
  },
  {
    element: <SecurityFeed />,
    exact: true,
    label: 'Security Feed',
    path: '/security-feed',
    title: 'Hummingbird | Security Feed',
  },
  {
    element: <About />,
    exact: true,
    label: 'About Hummingbird',
    path: '/about',
    title: 'Hummingbird | About',
  },
  {
    element: <Dashboard />,
    exact: true,
    path: '/preview',
    title: 'Hummingbird | Preview',
  },
];

const flattenedRoutes: IAppRoute[] = routes.reduce(
  (flattened, route) => [...flattened, ...(route.routes ? route.routes : [route])],
  [] as IAppRoute[],
);

const AppRoutes = (): React.ReactElement => (
  <Routes>
    {flattenedRoutes.map(({ path, element }, idx) => (
      <Route path={path} element={element} key={idx} />
    ))}
    <Route element={<NotFound />} />
  </Routes>
);

export { AppRoutes, routes };
